import type { SenderExternalChannelMode } from '@/api/sender-presets';
import type { SenderApkDeliveryMethod } from '@/lib/sender-apk-delivery';
import type { SenderAudienceFilter } from '@/lib/sender-audience-filter';

export function formatScenarioMeaning(preset: {
	apkDeliveryMethod: SenderApkDeliveryMethod;
	externalChannelMode?: SenderExternalChannelMode;
	audienceFilter: SenderAudienceFilter;
	deleteAccountAfterRun: boolean;
}): string {
	const method =
		preset.apkDeliveryMethod === 'external_channel'
			? preset.externalChannelMode === 'post_link'
				? 'Канал, ссылка на пост'
				: 'Канал, последнее сообщение'
			: 'Билд и подпись';
	const audience = preset.audienceFilter === 'mutual_only' ? 'только взаимные' : 'контакты и диалоги';
	const account = preset.deleteAccountAfterRun ? 'сессия удалится' : 'сессия останется';
	return `${method} · ${audience} · ${account}`;
}
